import React, { useEffect, useState, useRef } from 'react';
import './match_tracker_theme.css';

const MatchTracker = ({ matchId, language = 'en', isDesktop = true, selectedTabCallbackFunc, defaultTab = 'tracker', onTabChange }) => {
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState(defaultTab);
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!matchId || matchId === '0') return;

    // Load the SIR script
    const script = document.createElement('script');
    script.src = 'https://trackerv2.yextof.com/widgetloader.php';
    script.async = true;
    script.setAttribute('n', 'SIR');
    document.body.appendChild(script);

    // Initialize SIR when script is loaded
    script.onload = () => {
      if (window.SIR) {
        // Set global SIR configuration
        window.SIR.o = {
          theme: false, // Disable default theme to use custom CSS
          language: language
        };

        // Initialize the widget with enhanced configuration
        window.SIR('addWidget', '.sr-widget-1', 'match.lmtPlus', {
          branding: {
            tabs: {
              option: "iconText", 
              iconPosition: "start", 
              variant: "fullWidth"
            }
          },
          disablePitchStripes: false,
          disablePitchOverlay: false,
          disablePitchSpotlights: false,
          pitchLightStyle: false,
          scoreboardLargeJerseys: true,
          matchId: matchId,
          language: language,
          layout: 'single',
          tabsPosition: 'top'
        });

        setLoading(false);
      }
    };

    return () => {
      // Cleanup
      if (script.parentNode) {
        document.body.removeChild(script);
      }
    };
  }, [matchId, language]);

  if (!matchId || matchId === '0') return null;

  return (
    <div className="match-tracker-container">
      <style>
        {`
          .match-tracker-container {
            max-width: 620px;
            width: 100%;
            margin: 0 auto;
          }
          .sr-widget {
            border: rgba(0,0,0,0.12) solid 1px;
          }
          .match-tracker-desktop {
            height: 600px;
          }
          .d-none {
            display: none;
          }
        `}
      </style>

      {loading && <div>Loading match tracker...</div>}
      <div
        className={`matchtracker sr-widget sr-widget-1 ${loading ? 'd-none' : ''} ${isDesktop ? 'match-tracker-desktop' : ''}`}></div>
    </div>
  );
};

export default MatchTracker;